import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CarouselBox = styled(Box)(() => ({
  width:"100%"
}));

export const HeroBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column-reverse",
  gap: "1rem",
  marginTop: "2rem",
  width:"100%"
}));
